var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-per"},[_vm._v("全"+_vm._s(_vm.total)+"件｜"+_vm._s(_vm.offset)+"～"+_vm._s(_vm.limit)+"件表示")])}
var staticRenderFns = []

export { render, staticRenderFns }